import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

const IconFingerprint = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <g>
        <path
          fill={fill}
          opacity={0.3}
          d='M21,9a1,1,0,0,1-1-1V4.5c0-.449-.052-.5-.5-.5H16a1,1,0,0,1,0-2h3.5A2.32,2.32,0,0,1,22,4.5V8A1,1,0,0,1,21,9ZM4,8V4.5c0-.449.052-.5.5-.5H8A1,1,0,0,0,8,2H4.5A2.32,2.32,0,0,0,2,4.5V8A1,1,0,0,0,4,8ZM9,21a1,1,0,0,0-1-1H4.5c-.448,0-.5-.051-.5-.5V16a1,1,0,0,0-2,0v3.5A2.32,2.32,0,0,0,4.5,22H8A1,1,0,0,0,9,21Zm13-1.5V16a1,1,0,0,0-2,0v3.5c0,.449-.052.5-.5.5H16a1,1,0,0,0,0,2h3.5A2.32,2.32,0,0,0,22,19.5Z'
        />
        <path
          fill={fill}
          opacity={0.3}
          d='M16.915,7.472a1,1,0,0,0-1.623,1.169A3.776,3.776,0,0,1,16,10.863v4.168a3.718,3.718,0,0,1-.514,2.206,1.007,1.007,0,0,0,.819,1.573c1.547-.181,1.683-2.927,1.7-3.779C17.917,12.855,18.449,9.271,16.915,7.472Z'
        />
        <path
          fill={fill}
          opacity={0.3}
          d='M12.264,7.021a1,1,0,0,0,1.113-.873c.108-.873-.776-1.23-1.514-1.148A5.869,5.869,0,0,0,6,10.863v3.082a1,1,0,0,0,2,0V10.863A3.863,3.863,0,0,1,12.264,7.021Z'
        />
        <path
          fill={fill}
          d='M14.73,10.438a2.866,2.866,0,0,0-5.635.714c.006.114-.005,1.62,0,1.781v1.012a2.509,2.509,0,0,1-.434,1.284,1,1,0,0,0,.185,1.4c1.517.979,2.281-1.784,2.249-2.686,0-.723,0-2.064,0-2.793a.871.871,0,0,1,1.668-.334,13.633,13.633,0,0,1,.068,2.115v1.574a3.253,3.253,0,0,1-.961,2.734,1,1,0,0,0,1.3,1.518,5.225,5.225,0,0,0,1.658-4.252A31.962,31.962,0,0,0,14.73,10.438Z'
        />
      </g>
    </svg>
  )
}

export default IconFingerprint
